import React, { Component } from 'react';
import { Alert, Container, Row, Form, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isMobile } from '../../utils/deviceInfo';

import axios from '../../axios';
import './Login.css';
import { validateEmail } from '../../utils/validations';
import Logo  from '../../components/Logo/Logo';
import LoginSide from '../../components/LoginSide/LoginSide';
import * as url from '../../utils/url';

class FindOrganization extends Component {

	constructor(props) {
		super(props);
		this.state = {
			email: {
				value: null,
				error: false
			},
			errorMessage: '',
			isSubmitted:false,
			isOrgFound:true
		}
	}

	handleEmailChange = ({ target }) => {
		const { value } = target;
		const { email } = this.state;
		email.value = value;
		email.error = false;
		this.setState({
			email
		});
	}

	handleSendResetLink = (e) => {
		let emailVal = this.state.email.value;
		const isValidEmail = validateEmail(emailVal);
		this.setState({errorMessage:"", isOrgFound:true})
		console.log(emailVal)
		if (!isValidEmail || !emailVal || emailVal==="" || emailVal==="undefined" || emailVal===null) {
			this.setState({
				email: {
					value: emailVal,
					error: !isValidEmail
				}
			})
			e.preventDefault()
		}
		if (isValidEmail) {
			e.preventDefault()
			console.log("clear!")
			let domain = emailVal.split("@")[1]
			// let domainIdx = domainSub.indexOf(".")
			// let domain = domainSub.slice(0, domainIdx)
			emailVal=emailVal.toLowerCase()
			let payload = {emailVal, domain}
			console.log('--pay--',payload)
			// return
			axios.post(url.checkOrgEmail, payload, {headers: {
				'Authorization': 'Bearer basicauth'
			  }}).then(({data}) => {
				if(data.data.length===0){
					this.setState({isOrgFound: false, isSubmitted:false})
				} else {
					this.setState({isOrgFound: true, isSubmitted:true})
				}
			}).catch(errors => {
				// console.log(errors, errors.error, errors.err, errors.message, errors.errors)
				this.setState({ ...this.state, isOrgFound: false});
			})
			e.preventDefault()
		}

	}

	handleReturnToLogin = () => {
		this.props.history.push({
			pathname: 'login',
			state: {isFromResetLink: true, isLogin:true}
		});
	}

	handleKeyPress = (e) => {
		// e.preventDefault()
		console.log(e)
		if (e.key === 'Enter' || e.keyCode===13 || e.charCode===13) {
			e.preventDefault()
		  this.handleSendResetLink(e);
		}
	  }

	renderAlert = ()=>{
		let {isOrgFound}=this.state
		if (!isOrgFound) {
			return  (
				<div className="alert-msg-bg mt50">
					<i className="close-icon" onClick={() => this.setState({ isOrgFound: true })}>close</i>
					<div className="d-flex custom-message-box">
						<i className="material-icons alert-icon-bg">remove_circle</i>
						<span className="ml10 alert-msg-text">
						A user with this email already exists or no Enterprise was associated with this email domain.
						</span>
					</div>
				</div>)
		}
	}


	renderForm=()=>{
		let {isSubmitted, email, errorMessage,  } = this.state
		console.log()
		let alert = null;
		if (isSubmitted){
			return (
					<div >
						<div className="text-left mt50 reset-password-title">
						Please check your emails to activate your login
						</div>
						{/* <div className="text-left mt10 reset-link-desc">
							A login link has been sent to the email address you provided.
						</div> */}
						<div className="text-left mt20 reset-link-desc">
						A login link was sent to the email address you provided. If you don’t see it in a few minutes, 
						please check your spam folder for an email from <span className="primary-color">team@ouroffice.io</span>.
						</div>
						<div className="text-center mt30">
							<Button className="btn-send-reset-link" onClick={this.handleReturnToLogin}>
								<span className="txt-send-reset-link">Return to Login</span>
							</Button>
						</div>
					</div>
				)
		} else {
			return (
				<div>
				<div className={` ${isMobile ? 'mt30 pl-3':'mt50'} text-left reset-password-title`}>
					New User  
							</div>
							<div className={` ${isMobile ? 'mt-0 pl-3':'mt10'} text-left reset-password-desc`}>
							Please enter your email below. Then check your email account to activate your login.
							</div>
							{this.renderAlert()}
							<Form className={`${isMobile ? 'mt20':'mt30'}`}>
								<FormGroup>
									<Label for="email" className="label-login-email">Email Address</Label>
									<Input
										type="email"
										name="email"
										id="email"
										className={`${isMobile && 'mb100'} inputBox-height`}
										onChange={this.handleEmailChange}
										invalid={email.error}
										onKeyPress={this.handleKeyPress}

									/>
									<FormFeedback>Please enter valid email address.</FormFeedback>
								</FormGroup>
								<div className="text-center mt30">
									<Button onClick={this.handleSendResetLink} className="btn-send-reset-link"><span className="txt-send-reset-link">
										Submit
									</span></Button>
								</div>

								{errorMessage!=""?
								<p>{errorMessage}</p>
								:
								null}

								<div className="text-center mt30">
									<Link to={'/login'} className="link-go-back">Go Back</Link>
								</div>
							</Form>
			</div>
			)

		}
	}

	render() {
		let alert = null;
		let { email, errorMessage } = this.state;

		return (
			<Container className="login-layout-container">
				<Row className="login-outer-wrapper">
					<div id="login-main" className="col-sm-10 col-md-10 login-card-box">
						<div id="login-main-wrapper" className="white-background">
							<Logo />

							{this.renderForm()}

						</div>
					</div>
					{ !isMobile && <LoginSide /> }
				</Row>
				<Row>
					<div id="login-secondary" className="col-sm-12 mb10 pl30">
						<div className="text-center">
							© {new Date().getFullYear()} <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
						</div>
					</div>
				</Row>
			</Container>
		)
	}
}

export default FindOrganization;
